<template>
  <v-dialog v-model="showDialog" max-width="370" persistent>
    <ValidationObserver v-slot="{ invalid }" ref="inviteCodeObserver">
      <v-card>
        <v-card-title class="headline">{{ $tc('friendInvite.friendInviteRedeemDialogTitle', inviteeAcceptPoints) }}</v-card-title>

        <v-card-text>
          {{ $tc('friendInvite.friendInviteRedeemDialogDescription', inviteeAcceptPoints) }}
          <div>
            <ValidationProvider name="inviteCode" slim rules="required" v-slot="{ errors }">
              <v-text-field
                class="invite-code-input primary--text"
                v-model="inviteCode"
                :error-messages="errors[0]"
                :placeholder="$t('friendInvite.friendInviteRedeemPlacholderText')"
                hide-details></v-text-field>
            </ValidationProvider>
          </div>

          <v-alert type="error" class="caption mt-4" v-if="responseError" dense>{{ errorMessage }}</v-alert>
          <v-alert type="success" class="caption mt-4" v-if="responseSuccess" dense>{{ successMessage }}</v-alert>

        </v-card-text>
        <v-card-actions v-if="responseSuccess">
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="closeDialog">OK</v-btn>
        </v-card-actions>

        <v-card-actions v-else>
          <v-spacer></v-spacer>
          <v-btn text @click="closeDialog">{{ $t('friendInvite.friendInviteRedeemDialogCancel') }}</v-btn>
          <v-btn color="primary" text @click="redeemInviteCode" :disabled="invalid" :loading="loadingRedeem">
            {{ $t('friendInvite.friendInviteRedeemDialogButtonText') }}
          </v-btn>
        </v-card-actions>

      </v-card>
    </ValidationObserver>
  </v-dialog>
</template>

<script>
  import _ from 'lodash';
  import {mapGetters} from 'vuex'
  import {BASE_API_URL, storage} from '@/store'

  export default {
    name: "FriendInviteRedeemDialog",
    data() {
      return {
        inviteCode: '',
        loadingRedeem: false,
        showDialog: false,
        responseError: false,
        responseSuccess: false,
        successMessage: '',
        errorMessage: this.$t('friendInvite.friendInviteMissingCode')
      }
    },
    computed: {
      ...mapGetters(['extensionSettings', 'customerRelationship', 'client_id']),
      inviteeAcceptPoints() {
        return _.get(this.extensionSettings, 'friend-invites.invitee_accept_points')
      },
      canRedeemInviteCode() {
        return _.get(this.customerRelationship, 'can_redeem_invite_code', false);
      },
      showFriendInviteRedeemDialog() {
        return this.$store.state.showFriendInviteRedeemDialog;
      }
    },
    methods: {
      setInviteCodeFromStorage() {
        const inviteCodeObj = JSON.parse(storage.getItem('inviteCode'));
        if (inviteCodeObj && inviteCodeObj.code) {
          this.inviteCode = inviteCodeObj.code;
        }
      },
      showRedeemDialog(show) {
        if (show) {
          if (this.canRedeemInviteCode) {
            this.showDialog = true;
            this.setInviteCodeFromStorage();
            if (this.inviteCode) {
              this.redeemInviteCode();
            }
          }
        } else {
          this.showDialog = false;
        }
      },
      async redeemInviteCode() {
        const body = JSON.stringify({invite_code: this.inviteCode});
        this.responseError = false,
        this.responseSuccess = false;

        try {
          const response = await this.axios.post(`${BASE_API_URL}/api/v1/clients/${this.client_id}/invite-code-redeem/`, body);

          if (response.data.success) {
            this.responseSuccess = true;
            const points = _.get(response.data, 'points', 0);
            const responseCode = _.get(response.data, 'code');

            this.successMessage = this.$tc('friendInvite.friendInviteCongratsText', points);

            if (responseCode === 'INVITE_NEEDS_EMAIL_VERIFICATION') {
              this.successMessage = this.$t('friendInvite.friendInviteCongratsNeedsEmailVerificationText');
            }

            this.$store.dispatch('fetchCustomerRelationship');
            this.clearInviteCode();
            storage.setItem('inviteCodeRedeemed', 1);
          }
        } catch (error) {
          const {response} = error;
          this.responseError = true;
          let timeout = _.get(this.extensionSettings, 'friend-invites.redeem_timeout', 1);

          if (_.get(response, 'data.code')) {
            if (response.data.code === 'INVITE_CODE_INVALID') {
              timeout = 0;
            }
            this.errorMessage = this.$tc('friendInvite.friendInviteCannotRedeem', timeout);
          }
        } finally {
          this.loadingRedeem = false;
        }
      },
      resetDialog() {
        this.inviteCode = '';
        this.$refs.inviteCodeObserver.reset();
        this.errorMessage = this.$t('friendInvite.friendInviteMissingCode');
        this.responseError = false;
      },
      closeDialog() {
        this.resetDialog();
        this.$store.dispatch('setFriendInviteRedeem', false);
        this.$emit('next');
      },
      clearInviteCode() {
        storage.removeItem('inviteCode');
      }
    },
    watch: {
      showFriendInviteRedeemDialog: {
        immediate: true,
        handler(show) {
          this.showRedeemDialog(show);
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .invite-code-input {
    width: 250px;
    margin-left: auto;
    margin-right: auto;
    &::v-deep input {
      text-align: center;
      color: inherit !important;
    }
  }
</style>
